const detailFieldSx = {
	minWidth: 0,
	'& .MuiInputBase-root': {
		height: '40px',
		p: '0 12px',
		fontSize: '14px',
		lineHeight: '20px',
	},
	'& .MuiInputBase-input': {
		height: '20px',
		p: 0,
		minWidth: 0,
		lineHeight: '20px',
		textOverflow: 'ellipsis',
	},
};

export default detailFieldSx;
